<template>
    <el-scrollbar id="left-nav"> 
        <div class="logo">
          <img src="@/assets/yanyun.png">
        </div>
        <el-menu :default-active='activeItem' @select='clickMenuItem'  unique-opened background-color="#3B3A54" text-color="#93bae8" active-text-color="#fff">
<!--             <el-menu-item key="home" index="home" >
                <h2>首页</h2>
            </el-menu-item> -->
            <el-submenu v-for="menu in subMenu" :key="menu.id" :index='menu.id' >
                <template slot="title">
                    <svg class="se-icon" aria-hidden="true">
                        <use :xlink:href="menu.icon"></use>
                    </svg> 
                    <span>{{menu.name}}</span>
                </template> 
                <el-menu-item v-for="item in itemMenu(menu.id,null)" :key="item.index" :index="item.index" :id="getId(item.path)">
                    {{item.name}}
                </el-menu-item>
            </el-submenu>            
        </el-menu>
    </el-scrollbar> 
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";

export default {
  data() {
    return{
      isCcollapse:true
    }
  },
  mounted() {
    this.getMenu();
    // this.clickMenuItem("adminIndex");
  },
  methods: {
    handleOpen (key, keyPath) {
      console.log(key, keyPath)
    },
    handleClose (key, keyPath) {
      console.log(key, keyPath)
    },
    toggleCollapse () {
      console.log(123456789);
      
      this.isCollapse = !this.isCollapse
    },
    ...mapActions("menu", {
      getMenu: "getMenu",
      clickMenuItem: "clickMenuItem"
    })
  },
  computed: {
    ...mapState("menu", {
      menu: "menu",
      activeItem: "activeItem"
    }),
    ...mapGetters("menu", {
      subMenu: "subMenu",
      groupMenu: "groupMenu",
      itemMenu: "itemMenu"
    }),
    getId(){
      return function (path) {
        return path.split('/')[2] || path.split('/')[1] + 'Menu';
      }
    }
  }
};
</script>

<style>

#left-nav .el-submenu__title *{
  font-size: 16px;
}
#left-nav .el-menu-item, .el-submenu__title {
  height: 60px;
  line-height: 60px;
  color: rgb(211, 223, 236) !important;
  box-sizing: border-box;
  font-size: 15px;
}
#left-nav .el-menu-item.is-active {
    color: #fff !important;
    /* background-color: rgb(42, 115, 190)!important; */
    background-color:#34344B!important;
}
#left-nav .el-submenu__title i {
    color: #d8d8d8;

}
#left-nav .el-submenu.is-active .el-submenu__title {
  color: #fff !important;
  /* background: #005279 !important; */
  background: #34344B !important;
  /* border-bottom: 2px solid #7bf211; */
}
#left-nav .logo{
  width:100%;
  height: 60px;
  box-sizing: border-box;
  box-shadow: 0px -2px 2px 0px #e5e5e5 inset;
}
#left-nav .logo > img{
  height: 36px;
  margin-top: 12px;
  margin-left: 15px;
}
</style>
